import { render, staticRenderFns } from "./NewMessageThread.vue?vue&type=template&id=14232fd3&"
import script from "./NewMessageThread.vue?vue&type=script&lang=js&"
export * from "./NewMessageThread.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageThread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports